import { writable } from 'svelte/store';
const sampleInfo = writable(null);
const sample = writable(null);
export default sample;
export { sample, sampleInfo, };
